<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { useSettings } from '@/login/composables/useSettings';
import TemplateLogin from '@/views/newlogin/templates/TemplateLogin.vue';
import TemplateLoginCard from './templates/TemplateLoginCard.vue';
import SelectInstance from '../SelectInstance.vue';
import Progressbar from '@/components/common/Progressbar.vue';

const loginStore = useLoginStore();
const { isInstanceSelected, instanceCount, instancesLoading } = storeToRefs(loginStore);
const { instanceSettingsMissing } = useSettings();
</script>

<template>
    <TemplateLogin>
        <SelectInstance v-if="!isInstanceSelected && instancesLoading === 0" />
        <TemplateLoginCard v-else-if="instancesLoading > 0">
            <SStack vertical gap="5">
                <SText>{{ $t('system.loggingIn') }}</SText>
                <Progressbar :total="instanceCount" :success="instanceCount - instancesLoading" />
            </SStack>
        </TemplateLoginCard>
        <TemplateLoginCard v-else-if="instanceSettingsMissing === true">
            <SHeading is="h2" class="mb-3">{{ $t('modules.login.criticalSettingsMissing.header') }}</SHeading>
            <SText>{{ $t('modules.login.criticalSettingsMissing.description') }}</SText>
        </TemplateLoginCard>
    </TemplateLogin>
</template>
